import React, { useState } from 'react';
import { useAppContext } from './context/AppContext';
import LoginPage from './pages/LoginPage';
import ProfilePage from './pages/ProfilePage';
import SuperAdminPage from './pages/SuperAdminPage';
import BudgetPage from './pages/BudgetPage';
import FamilyPage from './pages/FamilyPage';
import VerifyEmailPage from './pages/VerifyEmailPage';
import WelcomePage from './pages/WelcomePage';
import CategoriesPage from './pages/CategoriesPage';
import ManageDefaultCategoriesPage from './pages/ManageDefaultCategoriesPage';
import HelpPage from './pages/HelpPage';

function App() {
    const { user, isLoading, isProfileComplete } = useAppContext();
    const [currentPage, setCurrentPage] = useState('budget');

    const navigateTo = (page) => {
        setCurrentPage(page);
    };

    if (isLoading) {
        return <div className="min-h-screen flex items-center justify-center"><p>Loading...</p></div>;
    }

    if (!user) return <LoginPage />;
    if (!user.emailVerified) return <VerifyEmailPage />;
    if (!isProfileComplete) return <WelcomePage />;
    
    const props = { navigateTo, currentPage };

    switch (currentPage) {
        case 'profile': return <ProfilePage {...props} />;
        case 'superAdmin': return <SuperAdminPage {...props} />;
        case 'family': return <FamilyPage {...props} />;
        case 'categories': return <CategoriesPage {...props} />;
        case 'manageDefaultCategories': return <ManageDefaultCategoriesPage {...props} />;
        case 'help': return <HelpPage {...props} />;
        case 'budget':
        default: return <BudgetPage {...props} />;
    }
}

export default App;